import React, { useState, useRef, useEffect } from 'react';
import './style.css';

/**
 * ProgressiveImage — Exibe um placeholder (skeleton) enquanto a imagem
 * carrega, com lazy loading nativo e fade-in suave ao completar.
 */
const ProgressiveImage = ({ src, alt, className, style, onClick }) => {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);
  const imgRef = useRef(null);

  // Reset quando a src mudar
  useEffect(() => {
    setLoaded(false);
    setError(false);
  }, [src]);

  // Se a imagem já estiver em cache, marca como carregada imediatamente
  useEffect(() => {
    if (imgRef.current && imgRef.current.complete && imgRef.current.naturalWidth > 0) {
      setLoaded(true);
    }
  }, [src]);

  const handleLoad = () => {
    setLoaded(true);
  };

  const handleError = () => {
    setError(true);
    setLoaded(true);
  };

  if (error) {
    return (
      <div
        className={`progressive-image-placeholder ${className || ''}`}
        style={style}
      >
        <span className="progressive-image-error-icon">🍽️</span>
      </div>
    );
  }

  return (
    <div
      className={`progressive-image-wrapper ${className || ''}`}
      style={style}
      onClick={onClick}
    >
      {/* Skeleton placeholder */}
      {!loaded && <div className="progressive-image-skeleton" />}

      {/* Imagem real com lazy loading */}
      <img
        ref={imgRef}
        src={src}
        alt={alt || ''}
        loading="lazy"
        decoding="async"
        className={`progressive-image ${loaded ? 'progressive-image--loaded' : ''}`}
        onLoad={handleLoad}
        onError={handleError}
      />
    </div>
  );
};

export default ProgressiveImage;
